import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import moment from 'moment-timezone';

import { InfoboxComponent } from '@recruitee/components/infobox';
import { I18nService, TranslatePipe } from '@recruitee/i18n';

@Component({
  selector: 'rt-subscription-future-status-info',
  templateUrl: './subscription-future-status-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InfoboxComponent, TranslatePipe],
})
export class SubscriptionFutureStatusInfoComponent {
  @Input() public currentPeriodStart: string | undefined;

  public message: string;

  constructor(private i18n: I18nService) {}

  public ngOnInit(): void {
    const date = moment(this.currentPeriodStart).format('DD MMMM YYYY');

    this.message = this.i18n.translate(
      'app.pricing.billing_page.subscription_future_infobox.message',
      { date: date },
    );
  }
}
